import { render, staticRenderFns } from "./RenderForReview.vue?vue&type=template&id=3f8d69c0&scoped=true"
import script from "./RenderForReview.vue?vue&type=script&lang=js"
export * from "./RenderForReview.vue?vue&type=script&lang=js"
import style0 from "./RenderForReview.vue?vue&type=style&index=0&id=3f8d69c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8d69c0",
  null
  
)

export default component.exports